<template>
  <FriedTableRow>
    <FriedTableCell>
      <FriedSkeleton :type="SkeletonType.Paragraph" :rows="1" />
    </FriedTableCell>
    <FriedTableCell class="hidden-xs-and-down">
      <FriedSkeleton :type="SkeletonType.Avatar" />
    </FriedTableCell>
    <FriedTableCell class="hidden-sm-and-down">
      <FriedSkeleton :type="SkeletonType.Paragraph" :rows="1" />
    </FriedTableCell>
    <FriedTableCell class="hidden-md-and-down">
      <FriedSkeleton :type="SkeletonType.Paragraph" :rows="1" />
    </FriedTableCell>
    <FriedTableCell class="hidden-md-and-down">
      <FriedSkeleton :type="SkeletonType.Paragraph" :rows="1" />
    </FriedTableCell>
    <FriedTableCell v-if="isEditSite" class="hidden-md-and-down">
      <FriedSkeleton :type="SkeletonType.Paragraph" :rows="1" />
    </FriedTableCell>
    <FriedTableCell :align="TableAlign.Right">
      <FriedSkeleton :type="SkeletonType.ButtonIcon" />
    </FriedTableCell>
  </FriedTableRow>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SkeletonType, TableAlign } from '@getaccept/fried-tofu';

export default defineComponent({
  props: {
    isEditSite: {
      type: Boolean,
    },
  },
  setup() {
    return { SkeletonType, TableAlign };
  },
});
</script>
